import { c as _c } from "react/compiler-runtime";
import { type HTMLAttributes } from "react";
import Image from "next/image";
import { ImageVisa, ImageMastercard, ImageAmex, ImageDiscover, ImageApple, ImageGoogle, ImagePaypal } from "./images";
import { cn } from "@local/utils/src/cn";
interface CreditCardsProps extends HTMLAttributes<HTMLDivElement> {
  grayscale?: boolean;
  showPayPal?: boolean;
}
export const CreditCards = t0 => {
  const $ = _c(23);
  let className;
  let rest;
  let showPayPal;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      grayscale: t1,
      showPayPal,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = showPayPal;
    $[4] = t1;
  } else {
    className = $[1];
    rest = $[2];
    showPayPal = $[3];
    t1 = $[4];
  }
  const grayscale = t1 === undefined ? false : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      name: "Visa",
      src: ImageVisa
    };
    t3 = {
      name: "Mastercard",
      src: ImageMastercard
    };
    t4 = {
      name: "American Express",
      src: ImageAmex
    };
    t5 = {
      name: "Discover",
      src: ImageDiscover
    };
    t6 = {
      name: "Apple Pay",
      src: ImageApple
    };
    t7 = {
      name: "Google Pay",
      src: ImageGoogle
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
  }
  let cards;
  if ($[11] !== showPayPal) {
    cards = [t2, t3, t4, t5, t6, t7];
    if (showPayPal) {
      let t8;
      if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
          name: "Paypal",
          src: ImagePaypal
        };
        $[13] = t8;
      } else {
        t8 = $[13];
      }
      cards.push(t8);
    }
    $[11] = showPayPal;
    $[12] = cards;
  } else {
    cards = $[12];
  }
  const t8 = grayscale ? "grayscale" : "";
  let t9;
  if ($[14] !== className || $[15] !== t8) {
    t9 = cn("ml-auto max-w-[520px] rounded-full bg-white px-2 py-1 filter lg:block", t8, className);
    $[14] = className;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== cards) {
    t10 = <div className="flex w-full flex-row items-center justify-between space-x-2 overflow-hidden align-middle">{cards.map(_temp)}</div>;
    $[17] = cards;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== rest || $[20] !== t10 || $[21] !== t9) {
    t11 = <div className={t9} {...rest}>{t10}</div>;
    $[19] = rest;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
function _temp(t0) {
  const {
    name,
    src
  } = t0;
  return <div key={name} className="relative w-auto rounded-xs border-4 border-white bg-white"><Image alt={name} loading="lazy" width={46} height={48} src={src} className="w-auto object-contain" style={{
      color: "transparent"
    }} /></div>;
}